// Generated by purs version 0.13.0
"use strict";
var Chip_Action = require("../Chip.Action/index.js");
var Chip_Mutation_Level = require("../Chip.Mutation.Level/index.js");
var actAI = function ($0) {
    return Chip_Action.inactive(Chip_Mutation_Level.act($0));
};
module.exports = {
    actAI: actAI
};
